export default __webpack_public_path__ + "static/media/tipper_truck.20289632.jpg";